export default __webpack_public_path__ + "static/media/IconDesc_C_Inv_Ramp_8x2_01.256.1e954220.png";